import React from 'react'

function ProtectedRoute({user, user2, children}){

    if(user=== localStorage.getItem('AuthId')||user2=== localStorage.getItem('AuthId')){
        return children;
    }else{
        window.location.href = '/micarrito';
    }
   
}

export default ProtectedRoute;
